const UserActionTypes = {
    PUSH_ACCOUNT_PAGE: 'PUSH_ACCOUNT_PAGE',

    CHANGE_USER_STATUS: 'CHANGE_USER_STATUS',

    CHECK_USER_SESSION: 'CHECK_USER_SESSION',

    START_CHANGE_LANGUAGE: 'START_CHANGE_LANGUAGE',
    SUCCESS_CHANGE_LANGUAGE: 'SUCCESS_CHANGE_LANGUAGE',
    FAILURE_CHANGE_LANGUAGE: 'FAILURE_CHANGE_LANGUAGE',

    FETCH_USER_ADDRESSES: 'FETCH_USER_ADDRESSES',
    SUCCESS_USER_ADDRESSES: 'SUCCESS_USER_ADDRESSES',
    FINISH_USER_ADDRESSES: 'FINISH_USER_ADDRESSES',
    FAILURE_USER_ADDRESSES: 'FAILURE_USER_ADDRESSES',

    SIGN_OUT_START: 'SIGN_OUT_START',
    SIGN_OUT_SUCCESS: 'SIGN_OUT_SUCCESS',
    SIGN_OUT_FAILURE: 'SIGN_OUT_FAILURE',

    AUTHENTICATE_USER: 'AUTHENTICATE_USER',

    SIGN_IN_START: 'SIGN_IN_START',
    SIGN_IN_AUTH_START: 'SIGN_IN_AUTH_START',
    SIGN_IN_2FA_START: 'SIGN_IN_2FA_START',
    SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
    SIGN_IN_FAILURE: 'SIGN_IN_FAILURE',
    SIGN_IN_FINISH: 'SIGN_IN_FINISH',
    SIGN_IN_ATTEMPT_EXPIRED: 'SIGN_IN_ATTEMPT_EXPIRED',

    SIGN_UP_START: 'SIGN_UP_START',
    SIGN_UP_FAILURE: 'SIGN_UP_FAILURE',

    LOGOUT_START: 'LOGOUT_START',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    LOGOUT_FAILURE: 'LOGOUT_FAILURE',

    ON_FAILURE: 'ON_FAILURE',

    START_SWITCH_USER_ACCOUNT: 'START_SWITCH_USER_ACCOUNT',
    SUCCESS_SWITCH_USER_ACCOUNT: 'SUCCESS_SWITCH_USER_ACCOUNT',
    FINISH_SWITCH_USER_ACCOUNT: 'FINISH_SWITCH_USER_ACCOUNT',
    FAILURE_SWITCH_USER_ACCOUNT: 'FAILURE_SWITCH_USER_ACCOUNT',

    START_SWITCH_ONBOARDING_INTENT: 'START_SWITCH_ONBOARDING_INTENT',
    SUCCESS_SWITCH_ONBOARDING_INTENT: 'SUCCESS_SWITCH_ONBOARDING_INTENT',
    FINISH_SWITCH_ONBOARDING_INTENT: 'FINISH_SWITCH_ONBOARDING_INTENT',
    FAILURE_SWITCH_ONBOARDING_INTENT: 'FAILURE_SWITCH_ONBOARDING_INTENT',

    START_FETCH_USER_ACCOUNTS: 'START_FETCH_USER_ACCOUNTS',
    SUCCESS_FETCH_USER_ACCOUNTS: 'SUCCESS_FETCH_USER_ACCOUNTS',

    START_USER_ACCOUNTS_PERMISSIONS: 'START_USER_ACCOUNTS_PERMISSIONS',
    SUCCESS_USER_ACCOUNTS_PERMISSIONS: 'SUCCESS_USER_ACCOUNTS_PERMISSIONS',
    FINISH_USER_ACCOUNTS_PERMISSIONS: 'FINISH_USER_ACCOUNTS_PERMISSIONS',

    FETCH_ONBOARDING_FEE: 'FETCH_ONBOARDING_FEE',
    SUCCESS_ONBOARDING_FEE: 'SUCCESS_ONBOARDING_FEE',
    FAILURE_ONBOARDING_FEE: 'FAILURE_ONBOARDING_FEE',

    START_FETCH_ACTIVE_SERVICE_PLAN: 'START_FETCH_ACTIVE_SERVICE_PLAN',
    SUCCESS_FETCH_ACTIVE_SERVICE_PLAN: 'SUCCESS_FETCH_ACTIVE_SERVICE_PLAN',

    START_FETCH_IP_DATA: 'START_FETCH_IP_DATA',
    SUCCESS_FETCH_IP_DATA: 'SUCCESS_FETCH_IP_DATA',
    FAILURE_FETCH_IP_DATA: 'FAILURE_FETCH_IP_DATA',

    START_FETCH_SS_ACCESS_TOKEN: 'START_FETCH_SS_ACCESS_TOKEN',
    SUCCESS_FETCH_SS_ACCESS_TOKEN: 'SUCCESS_FETCH_SS_ACCESS_TOKEN',
    FAILURE_FETCH_SS_ACCESS_TOKEN: 'FAILURE_FETCH_SS_ACCESS_TOKEN',

    START_COMPLETE_USER_SS_ACCESS_VERIFICATION: 'START_COMPLETE_USER_SS_ACCESS_VERIFICATION',
    SUCCESS_COMPLETE_USER_SS_ACCESS_VERIFICATION: 'SUCCESS_COMPLETE_USER_SS_ACCESS_VERIFICATION',
    FAILURE_COMPLETE_USER_SS_ACCESS_VERIFICATION: 'FAILURE_COMPLETE_USER_SS_ACCESS_VERIFICATION',

    START_RESEND_CONFIRM_EMAIL: 'START_RESEND_CONFIRM_EMAIL',
    SUCCESS_RESEND_CONFIRM_EMAIL: 'SUCCESS_RESEND_CONFIRM_EMAIL',
    FAILURE_RESEND_CONFIRM_EMAIL: 'FAILURE_RESEND_CONFIRM_EMAIL',
    FINISH_RESEND_CONFIRM_EMAIL: 'FINISH_RESEND_CONFIRM_EMAIL',

    START_PASSWORD_RESET_REQUEST: 'START_PASSWORD_RESET_REQUEST',
    SUCCESS_PASSWORD_RESET_REQUEST: 'SUCCESS_PASSWORD_RESET_REQUEST',
    FINISH_PASSWORD_RESET_REQUEST: 'FINISH_PASSWORD_RESET_REQUEST',
    FAILURE_PASSWORD_RESET_REQUEST: 'FAILURE_PASSWORD_RESET_REQUEST',

    START_FETCH_LATEST_SESSIONS: 'START_FETCH_LATEST_SESSIONS',
    SUCCESS_FETCH_LATEST_SESSIONS: 'SUCCESS_FETCH_LATEST_SESSIONS',
    FINISH_FETCH_LATEST_SESSIONS: 'FINISH_FETCH_LATEST_SESSIONS',
    FAILURE_FETCH_LATEST_SESSIONS: 'FAILURE_FETCH_LATEST_SESSIONS',

    START_TEMPORARY_PASSWORD_CHANGE: 'START_TEMPORARY_PASSWORD_CHANGE',
    SUCCESS_TEMPORARY_PASSWORD_CHANGE: 'SUCCESS_TEMPORARY_PASSWORD_CHANGE',
    FINISH_TEMPORARY_PASSWORD_CHANGE: 'FINISH_TEMPORARY_PASSWORD_CHANGE',
    FAILURE_TEMPORARY_PASSWORD_CHANGE: 'FAILURE_TEMPORARY_PASSWORD_CHANGE',

    START_REFRESH_TOKEN: 'START_REFRESH_TOKEN',
    SUCCESS_REFRESH_TOKEN: 'SUCCESS_REFRESH_TOKEN',
    FINISH_REFRESH_TOKEN: 'FINISH_REFRESH_TOKEN',
    FAILURE_REFRESH_TOKEN: 'FAILURE_REFRESH_TOKEN',

    START_CHECK_USER_EMAIL_STATUS: 'START_CHECK_USER_EMAIL_STATUS',
    SUCCESS_CHECK_USER_EMAIL_STATUS: 'SUCCESS_CHECK_USER_EMAIL_STATUS',

    START_CONFIRM_USER_EMAIL: 'START_CONFIRM_USER_EMAIL',
    SUCCESS_CONFIRM_USER_EMAIL: 'SUCCESS_CONFIRM_USER_EMAIL',
    FINISH_CONFIRM_USER_EMAIL: 'FINISH_CONFIRM_USER_EMAIL',
    FAILURE_CONFIRM_USER_EMAIL: 'FAILURE_CONFIRM_USER_EMAIL',

    START_PLAYGROUND_MODE: 'START_PLAYGROUND_MODE',
    SUCCESS_PLAYGROUND_MODE: 'SUCCESS_PLAYGROUND_MODE',
    FINISH_PLAYGROUND_MODE: 'FINISH_PLAYGROUND_MODE',
    FAILURE_PLAYGROUND_MODE: 'FAILURE_PLAYGROUND_MODE',

    START_EXTERNAL_ACCOUNT_LINK: 'START_EXTERNAL_ACCOUNT_LINK',
    SUCCESS_EXTERNAL_ACCOUNT_LINK: 'SUCCESS_EXTERNAL_ACCOUNT_LINK',
    FINISH_EXTERNAL_ACCOUNT_LINK: 'FINISH_EXTERNAL_ACCOUNT_LINK',
    FAILURE_EXTERNAL_ACCOUNT_LINK: 'FAILURE_EXTERNAL_ACCOUNT_LINK',

    FETCH_DEFAULT_2FA_TYPE: 'FETCH_DEFAULT_2FA_TYPE',
    SUCCESS_DEFAULT_2FA_TYPE: 'SUCCESS_DEFAULT_2FA_TYPE',

    GET_USER_PHONE_CONFIRMATION: 'GET_USER_PHONE_CONFIRMATION',
    SUCCESS_USER_PHONE_CONFIRMATION: 'SUCCESS_USER_PHONE_CONFIRMATION',

    START_BUSINESS_REGISTRATION_SIGN_UP: 'START_BUSINESS_REGISTRATION_SIGN_UP',
    SUCCESS_BUSINESS_REGISTRATION_SIGN_UP: 'SUCCESS_BUSINESS_REGISTRATION_SIGN_UP',
    FAILURE_BUSINESS_REGISTRATION_SIGN_UP: 'FAILURE_BUSINESS_REGISTRATION_SIGN_UP',

    START_PUT_PERSONAL_QUESTIONNAIRE: 'START_PUT_PERSONAL_QUESTIONNAIRE',
    SUCCESS_PUT_PERSONAL_QUESTIONNAIRE: 'SUCCESS_PUT_PERSONAL_QUESTIONNAIRE',
    FINISH_PUT_PERSONAL_QUESTIONNAIRE: 'FINISH_PUT_PERSONAL_QUESTIONNAIRE',
    FAILURE_PUT_PERSONAL_QUESTIONNAIRE: 'FAILURE_PUT_PERSONAL_QUESTIONNAIRE',

    START_GET_COMPANIES_REGISTRATION_FEE: 'START_GET_COMPANIES_REGISTRATION_FEE',
    SUCCESS_GET_COMPANIES_REGISTRATION_FEE: 'SUCCESS_GET_COMPANIES_REGISTRATION_FEE',
    FINISH_GET_COMPANIES_REGISTRATION_FEE: 'FINISH_GET_COMPANIES_REGISTRATION_FEE',
    FAILURE_GET_COMPANIES_REGISTRATION_FEE: 'FAILURE_GET_COMPANIES_REGISTRATION_FEE',

    START_FETCH_IDENTITY: 'START_FETCH_IDENTITY',
    SUCCESS_FETCH_IDENTITY: 'SUCCESS_FETCH_IDENTITY',

    START_GET_IDENTITY_DEPOSIT_LIMITS: 'START_GET_IDENTITY_DEPOSIT_LIMITS',
    SUCCESS_GET_IDENTITY_DEPOSIT_LIMITS: 'SUCCESS_GET_IDENTITY_DEPOSIT_LIMITS',
    FINISH_GET_IDENTITY_DEPOSIT_LIMITS: 'FINISH_GET_IDENTITY_DEPOSIT_LIMITS',
    FAILURE_GET_IDENTITY_DEPOSIT_LIMITS: 'FAILURE_GET_IDENTITY_DEPOSIT_LIMITS',

    START_ACCEPT_AFFILIATE_TERMS_AND_CONDITIONS: 'START_ACCEPT_AFFILIATE_TERMS_AND_CONDITIONS',
    SUCCESS_ACCEPT_AFFILIATE_TERMS_AND_CONDITIONS: 'SUCCESS_ACCEPT_AFFILIATE_TERMS_AND_CONDITIONS',
    FINISH_ACCEPT_AFFILIATE_TERMS_AND_CONDITIONS: 'FINISH_ACCEPT_AFFILIATE_TERMS_AND_CONDITIONS',

    START_CHECK_EMAIL_AVAILABILITY: 'START_CHECK_EMAIL_AVAILABILITY',
    SUCCESS_CHECK_EMAIL_AVAILABILITY: 'SUCCESS_CHECK_EMAIL_AVAILABILITY',
    FAILURE_CHECK_EMAIL_AVAILABILITY: 'FAILURE_CHECK_EMAIL_AVAILABILITY',

    START_GET_IDENTITY_DEVICES: 'START_GET_IDENTITY_DEVICES',
    SUCCESS_GET_IDENTITY_DEVICES: 'SUCCESS_GET_IDENTITY_DEVICES',
    FINISH_GET_IDENTITY_DEVICES: 'FINISH_GET_IDENTITY_DEVICES',
    FAILURE_GET_IDENTITY_DEVICES: 'FAILURE_GET_IDENTITY_DEVICES',

    START_SIGN_OUT_DEVICE: 'START_SIGN_OUT_DEVICE',
    SUCCESS_SIGN_OUT_DEVICE: 'SUCCESS_SIGN_OUT_DEVICE',
    FINISH_SIGN_OUT_DEVICE: 'FINISH_SIGN_OUT_DEVICE',
    FAILURE_SIGN_OUT_DEVICE: 'FAILURE_SIGN_OUT_DEVICE',

    SET_SUMSUB_DOCUMENTS_SUBMITTED: 'SET_SUMSUB_DOCUMENTS_SUBMITTED',
}

export default UserActionTypes
